<template>
  <div>article</div>
</template>
<script>
export default {
  name: 'Artical',
};
</script>
